export const paymentMethodLabel = (paymentMethod) => {
  if (!paymentMethod) return 'N/A';
  switch (paymentMethod) {
    case 'CASH':
      return 'Cash';
    case 'CHEQUE':
      return 'Cheque';
    case 'BANK_TRANSFER':
      return 'Bank Transfer';
    case 'UPI':
      return 'UPI';
    case 'CARD':
      return 'Card';
    case 'OTHER':
      return 'Other';
    default:
      return 'N/A';
  }
};
